import { EventDetails, HandleEventDetailsChange } from './eventDetailsFormTypes';

type EventProfileLike = {
  id?: number | string;
  flow_option?: string | null;
  visibility_limit?: string | null;
  feedback_form_id?: number | null;
  booking_payment_terms_id?: number | null;
  image?: string | null;
};

export const parseOptionalInt = (value: string): number | null => {
  const parsed = value ? parseInt(value, 10) : NaN;
  return Number.isFinite(parsed) ? parsed : null;
};

export const findSelectedEventProfile = <T extends EventProfileLike>(
  profiles: T[] | undefined,
  value: string,
): T | undefined => {
  return (profiles || []).find((profile) => String(profile.id) === value);
};

export const applySelectedEventProfile = <T extends EventDetails>(params: {
  selectedProfile: EventProfileLike | undefined;
  handleDetailsChange: HandleEventDetailsChange<T>;
}) => {
  const { selectedProfile, handleDetailsChange } = params;

  handleDetailsChange('flow_option' as keyof T, selectedProfile?.flow_option || null);
  handleDetailsChange('visibility_limit' as keyof T, selectedProfile?.visibility_limit || null);

  if (selectedProfile?.feedback_form_id) {
    handleDetailsChange('feedback_form_id' as keyof T, selectedProfile.feedback_form_id);
  }

  handleDetailsChange('booking_payment_terms_id' as keyof T, selectedProfile?.booking_payment_terms_id || null);

  if (['attendanceOnly', 'full'].includes(selectedProfile?.flow_option || '')) {
    handleDetailsChange('gps_location' as keyof T, undefined);
  }

  if (selectedProfile?.image) {
    handleDetailsChange('image' as keyof T, selectedProfile.image);
  }
};
